import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { environment } from '../../../environment/environment';
import { DataSharingService } from '../../data-sharing/data-sharing.service';

export interface UpdateModuleVersionRequest {
  version_id: number;
  module_id?: number;
  valid_from?: string;
  valid_to?: string | null;
  maintenance_minutes?: number;
  descriptions?: Record<string, { language_code: string; translation_text: string }> | any;
}

export function updateModuleVersion(componentDataSourceService: ComponentDataSourceService) {
  const dataSharingService = componentDataSourceService.injector.get(DataSharingService);

  return {
    name: 'UpdateModuleVersion',
    description: 'Updates an existing module version',
    execute: (data: UpdateModuleVersionRequest): Observable<any> => {
      if (!data.version_id) {
        return of({ success: false, error: 'Missing required field: version_id' });
      }
      const payload: any = {};
      if (data.valid_from !== undefined) payload.valid_from = data.valid_from;
      if (data.valid_to !== undefined) payload.valid_to = data.valid_to === '' ? null : data.valid_to;
      if (data.maintenance_minutes !== undefined) payload.maintenance_minutes = data.maintenance_minutes;
      if (data.descriptions !== undefined) payload.descriptions = data.descriptions;

      return componentDataSourceService.http.put<any>(
        `${environment.apiUrl}/events/modules/versions/${data.version_id}`,
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      ).pipe(
        tap(() => {
          dataSharingService.setData('modules_updated', {
            timestamp: Date.now(),
            ...(data.module_id && { module_id: data.module_id })
          });
        }),
        catchError(err => {
          console.error('[UpdateModuleVersion] Error:', err);
          throw err;
        })
      );
    }
  };
}
